import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { actions } from '../redux/ProductReducer';
import { Loader } from '../../../common/components';
import AdminFeeDetails from '../components/AdminFeeDetails/AdminFeeDetails';
import InternalContainer from '../../layout/containers/Internal';

import { ICON_MAP } from '../../../common/components/SvgIcons/productIcons';
import ProductTemplateBox from '../components/ProductTemplateBox/ProductTemplateBox';
import { openModal } from '../../../common/components/Modal/ModalRedux';

const AdminFeesContainer = ({
  params,
  getProduct,
  fetchFees,

  updateAdminFees,
  adminFeeEditRates,
  adminFeeImportRates,
  openModal,
}) => {
  const [activeScheme, setActiveScheme] = useState();

  const { product, isLoading, feeList } = useSelector((state) => state.productManagement);

  const sortedFeeList = feeList?.sort((feeA, feeB) => {
    return feeA.attributes.version < feeB.attributes.version ? 1 : -1;
  });

  const { productId } = params;
  const currentProductId = product?.data?.id;
  useEffect(
    () => {
      if (!currentProductId || currentProductId !== productId) {
        getProduct(productId);
      }
    },
    [productId, currentProductId, getProduct],
  );

  useEffect(
    () => {
      fetchFees();
    },
    [fetchFees],
  );

  const update = (values) => {
    return updateAdminFees(values).then(() => {
      fetchFees();
    });
  };

  const handleRowClick = (schemeId) => {
    const scheme = feeList?.find((fee) => fee.id === schemeId);
    setActiveScheme(scheme);
  };

  const handleActivate = () => {
    openModal('activateSchemeForm');
  };

  if (!product || !feeList?.length || currentProductId !== productId) {
    return (
      <InternalContainer title={'Product Management'}>
        <Loader />
      </InternalContainer>
    );
  }
  const productCode = product.data.attributes.product_code;
  const productName = product.data.attributes.name;

  return (
    <div className="admin-area product-container">
      <InternalContainer title={'Product Management'}>
        <ProductTemplateBox
          title={'(Edit Fees)'}
          productIcon={ICON_MAP[productCode]}
          productName={productName}
        >
          <div>
            <AdminFeeDetails
              onEditRates={adminFeeEditRates}
              onImportRates={adminFeeImportRates}
              feeScheme={activeScheme ?? feeList?.[0]}
              feeSchemesList={sortedFeeList}
              onUpdate={update}
              isLoading={isLoading}
              onVersionSelect={handleRowClick}
              onActivate={handleActivate}
              onActivateComplete={fetchFees}
            />
          </div>
        </ProductTemplateBox>
      </InternalContainer>
    </div>
  );
};

export default connect(
  null,
  {
    fetchFees: actions.fetchFees,
    getFeeScheme: actions.getFeeScheme,
    getProduct: actions.getProduct,
    updateAdminFees: actions.updateAdminFees,
    adminFeeImportRates: actions.adminFeeImportRates,
    adminFeeEditRates: actions.adminFeeEditRates,
    openModal,
  },
)(AdminFeesContainer);
